import PhonelinkEraseIcon from "@mui/icons-material/PhonelinkErase";
import Box from "@mui/joy/Box";
import Typography from "@mui/joy/Typography";
import { useLocation } from "react-router-dom";
import { DocumentId } from "../../../models/document";
import { DocumentMetadataDrawer } from "../components/DocumentMetadataDrawer";
import { DocumentViewer } from "../components/DocumentViewer";

export default function DocumentById() {
  const location = useLocation();
  const document_id: string = location.pathname.split("/")[2];

  return (
    <>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <Box sx={{ display: "flex" }}>
          <Box sx={{ overflowY: "scroll", height: "100vh", flex: 1 }}>
            <DocumentViewer documentId={document_id as DocumentId} />
          </Box>
          <Box
            sx={{
              width: "30vw",
              minWidth: "350px",
              flexShrink: 0,
              background: "white",
              overflowY: "scroll",
              height: "100vh",
              borderLeft: "1px solid",
              borderLeftColor: "divider",
            }}
          >
            <DocumentMetadataDrawer documentId={document_id as DocumentId} />
          </Box>
        </Box>
      </Box>
      <Box
        sx={{
          display: { xs: "flex", md: "none" },
          width: "100vw",
          height: "100vh",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          gap: 2,
        }}
      >
        <PhonelinkEraseIcon sx={{ fontSize: "10rem" }} />
        <Typography component="div" level="title-lg">
          Page not optimized for small screen.
        </Typography>
        <Typography level="body-lg">Please use wider screen or zoom out.</Typography>
      </Box>
    </>
  );
}
